import type { ProviderChatThread } from "./types";

const VIRTUAL_PREFIX = "virtual:";

export function isVirtualThreadId(id: string): boolean {
  return id.startsWith(VIRTUAL_PREFIX);
}

export function virtualThreadId(userId: string): string {
  return `${VIRTUAL_PREFIX}${userId}`;
}

export function getVirtualThreadUserId(id: string): string | null {
  if (!isVirtualThreadId(id)) {
    return null;
  }
  return id.slice(VIRTUAL_PREFIX.length);
}

export function makeVirtualThread(provider: {
  userId: string;
  firstName: string | null;
  lastName: string | null;
  specialties?: { name: string; code: string }[];
}): ProviderChatThread {
  return {
    id: virtualThreadId(provider.userId),
    unread_count: 0,
    last_message: null,
    last_message_sender_user_id: null,
    last_message_time: null,
    last_read_at: null,
    archived_at: null,
    organization_participants: [],
    user_participants: [
      {
        id: provider.userId,
        first_name: provider.firstName,
        last_name: provider.lastName,
        specialty_name: provider.specialties?.[0]?.name ?? null,
        specialty_code: provider.specialties?.[0]?.code ?? null,
        last_read_at: null,
        last_reminder_sent_at: null,
        has_read_latest_message: false,
      },
    ],
  } as unknown as ProviderChatThread;
}
